export default __webpack_public_path__ + "static/media/Neoito.9d922ffb.mp4";